var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropletSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L495.6 461.8C506.1 438 512 411.7 512 384C512 292.8 381.8 109.9 345.4 60.5C339.5 52.5 330.2 48 320.2 48L319.8 48C309.8 48 300.5 52.5 294.6 60.5C279 81.7 246.1 127.4 213.7 179.9L73 39.1zM165 266.8C143.4 310.6 128 352.7 128 384C128 490 214 576 320 576C363.4 576 403.4 561.6 435.5 537.4L165 266.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletSlash);
export default __webpack_public_path__ + "static/media/droplet-slash.8c879dbcd8c34fc2a1238d0037094d4f.svg";
export { ForwardRef as ReactComponent };